import { render, staticRenderFns } from "./important_list.vue?vue&type=template&id=30c6eb96&scoped=true&"
import script from "./important_list.vue?vue&type=script&lang=js&"
export * from "./important_list.vue?vue&type=script&lang=js&"
import style0 from "./important_list.vue?vue&type=style&index=0&id=30c6eb96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c6eb96",
  null
  
)

export default component.exports